// extracted by mini-css-extract-plugin
export var rootContainer = "layout-module--root-container--1otiu";
export var headerContainer = "layout-module--header-container--2Poia";
export var mainContent = "layout-module--main-content--ZxiHY";
export var content = "layout-module--content--1WD_k";